import React, { useState, useEffect, useRef } from "react";
import { Trash2, Share2, Edit3, Archive,MessageCircle ,X,ChevronRight, ChevronDown } from "react-feather";
import { AddSquareDuotoneLine } from "../../../svgs/AddSquareDuotoneLine";
import { SearchLight } from "../../../svgs/SearchLight";
import { getChatHistoryChips } from "../../../services/iqApiV2";
import IOSSpinner from "../../HtmlElements/IOSSpinner";
import "./ChatV2HistoryPanel.css";
import { useUser } from "../../../context/UserContext";

const ActionSection = ({ onSearchClick, isHistoryVisible, onToggleHistory ,setSessionId,uniqueKey,setSelectedIndex}) => (
  <>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "1rem",
        width: "100%",
        height: "20%",
        gap: "0.7rem",
        backgroundColor: "#fff !important",
        fontSize: "0.9rem"
      }}
    >
      <button className="ai_assist_action_btn" onClick={(e)=>{
          e.preventDefault();
          e.stopPropagation();
          setSessionId(uniqueKey);
          setSelectedIndex(null);
        }}>
        <AddSquareDuotoneLine height="1.2rem" width="1.2rem" color="black" />
        <span className="ai_assist_aciton_btns_text" >New Chat</span>
      </button>

      <button className="ai_assist_action_btn" onClick={onSearchClick}>
        <SearchLight height="1.2rem" width="1.2rem" color="black" />
        <span className="ai_assist_aciton_btns_text">Search Chats</span>
      </button>
     <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <span className="recent-chats-label">Recent Chats</span>
      <button
        onClick={onToggleHistory}
        style={{
          cursor: "pointer",
          background: "transparent",
          border: "none",
          fontSize: "1rem",
          alignItems: "center",
          marginTop: "8px",
        }}
      >
         {/* {isHistoryVisible ? (
          <ChevronDown size={15} style={{ marginRight: "8px" ,color:"#888A8B"}} />
        ) : (
          <ChevronRight size={15} style={{ marginRight: "8px" ,color:"#888A8B"}} />
        )} */}
        <ChevronRight
          size={15}
          className={`chevron-icon ${isHistoryVisible ? "open" : ""}`}
          style={{ marginRight: "8px", color: "#888A8B" }}
        />

      </button>
      </div>
    </div>
  </>
);

const SearchChatsPopup = ({ isOpen, onClose, chatItems = [], onSelectChat,uniqueKey,setSelectedIndex,setSessionId }) => {
  const [query, setQuery] = useState("");
  const popupRef = useRef(null);

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        onClose(); // Close popup if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  if (!isOpen) return null; // Don't render if popup is closed

  const filtered = chatItems.filter(item =>
    item.heading?.toLowerCase().includes(query.toLowerCase())
  );

  // Handle selection of a chat
  const handleChatClick = (item) => {
    onSelectChat(item); // Pass the selected item to the parent
    onClose(); // Close the popup after selection
  };

  return (
    <div className="search-popup-overlay-cvhp">
      <div className="search-popup-panel-cvhp" ref={popupRef}>
        {/* HEADER */}
        <div className="search-popup-header-cvhp">
          <input
            type="text"
            placeholder="Search chats..."
            className="search-popup-input-cvhp"
            value={query}
            onChange={(e) => setQuery(e.target.value)} // Handle search input
          />
           <X
            size={20}
            className="search-popup-close-icon-cvhp"
            onClick={onClose}
          />
        </div>

        {/* DIVIDER */}
        <div className="search-popup-divider-cvhp" />
           <div className="search-chat-item-cvhp new-chat-row" onClick={(e)=>{
          e.preventDefault();
          e.stopPropagation();
          setSessionId(uniqueKey);
          setSelectedIndex(null);
          onClose()
        }}>
              
              <AddSquareDuotoneLine height="1.2rem" width="1.2rem" color="black" style={{ marginRight: "12px" }}/>
              New Chat
            </div>

        {/* LIST */}
        <div className="search-popup-list-cvhp">
          {filtered.length > 0 ? (
            filtered.map((item, index) => (
              <div
                key={index}
                className="search-chat-item-cvhp"
                onClick={() => handleChatClick(item)} // Select chat and close popup
              >
                <MessageCircle size={15} color="black" style={{ marginRight: "12px" }} />
                {item?.heading}
              </div>
            ))
          ) : (
            <div className="search-no-results-cvhp">No chats found</div>
          )}
        </div>
      </div>
    </div>
  );
};

function ChatHistorySection({ items = [], selectedIndex, onSelect }) {
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const menuRefs = useRef([]);
  const textRefs = useRef([]);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const chatItemRefs = useRef([]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutside = menuRefs.current.every(ref => {
        if (!ref) return true;
        return !ref.contains(event.target);
      });

      if (clickedOutside) {
        setActiveMenuIndex(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
  if (selectedIndex !== null && chatItemRefs.current[selectedIndex]) {
    // Scroll the selected chat into view
    chatItemRefs.current[selectedIndex].scrollIntoView({
      behavior: 'smooth', // Smooth scrolling
      block: 'center', // Center the chat item in the view
    });
  }
  }, [selectedIndex]);

  useEffect(() => {
  setIsOverflowing(items.map((_, index) => {
    const textElement = textRefs.current[index];
    return textElement ? textElement.scrollWidth > textElement.clientWidth : false;
  }));
}, [items]);

  const toggleMenu = (index) => {
    setActiveMenuIndex(activeMenuIndex === index ? null : index);
  };

  return (
    <div className="chat-history-section-cvhp">
      {items.map((item, index) => (
        <div
          key={index}
          className={`chat-history-item-container-cvhp ${
            selectedIndex === index ? "selected" : ""
          }`}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onSelect(index,item)}}
          ref={(el) => (chatItemRefs.current[index] = el)}
        >
          
          
            <div
            className="chat-history-item-cvhp"
            // Add title attribute conditionally based on item heading length
            title={item?.heading?.length > 15 ? item?.heading : undefined}
          >
            {item?.heading}
          </div>
          
          <div
            className="menu-wrapper-cvhp"
            ref={(el) => (menuRefs.current[index] = el)}
            // onClick={(e) => e.stopPropagation()}
          >
            <div className="menu-icon-cvhp" 
          
            onClick={(e) => {
               e.preventDefault()
            e.stopPropagation() 
              toggleMenu(index);
            }}
            >
              ...
            </div>

            {activeMenuIndex === index && (
              <div className="menu-popup-cvhp" 
              // onClick={(e) => e.stopPropagation()} 
            >
                {/* menu items */}
                <div className="menu-option-cvhp" onClick={() => setActiveMenuIndex(null)}>
                    <div className="menu-item-flex-cvhp">
                      <Edit3 size={16} style={{ marginRight: "6px" }} />
                      Rename
                    </div>
                  </div>

                  
                  {/* <div className="menu-option-cvhp" onClick={() => setActiveMenuIndex(null)}>
                    <div className="menu-item-flex-cvhp">
                      <Share2 size={16} style={{ marginRight: "6px" }}/>
                      Share
                    </div>
                  </div>

                  
                  <div className="menu-option-cvhp" onClick={() => setActiveMenuIndex(null)}>
                    <div className="menu-item-flex-cvhp">
                      <Archive size={16} style={{ marginRight: "6px" }}/>
                      Archive
                    </div>
                  </div> */}

                <div
                  className="menu-option-cvhp"
                  onClick={() => setActiveMenuIndex(null)}
                >
                  <div className="delete-cvhp">
                  <Trash2 size={16} style={{ marginRight: "6px" }} />
                  Delete
                  </div>
                </div>

              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

function ChatV2HistoryPanel({chatHeadings, setChatHeadings, setSessionId,selectedIndex, setSelectedIndex}) {
  const [loading, setLoading] = useState(true);
  const [isSearchOpen, setIsSearchOpen] = useState(false); 
  const [isHistoryVisible, setIsHistoryVisible] = useState(true);
  const {user}= useUser();
  const uniqueKey = `${Date.now()}_${user?.id}`;

  useEffect(() => {
    const fetchChatHistory = async () => {
      setLoading(true);
      const data = await getChatHistoryChips();
      if (data) setChatHeadings(data); // store API response
      setLoading(false);
    };
    fetchChatHistory();
    setSessionId(uniqueKey);
  }, []);

  // const handleChatSelect = (index) => {
  //   setSelectedIndex(index);
  //   console.log(`Chat with index ${index} selected.`);
  // };

  const toggleSearchPopup = () => setIsSearchOpen(!isSearchOpen);

  const handleSelectChatFromSearch = (selectedItem) => {
    console.log("selectedItem",selectedItem)
    setSessionId(selectedItem?._id)
    const index = chatHeadings.findIndex(c => c._id === selectedItem._id); 
    if (index !== -1) setSelectedIndex(index);
  };

  const handleSelectForHistoryPanel = (selectedItem)=>{
     setSessionId(selectedItem?._id)
     console.log("selectedItem",selectedItem)
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        borderRight: "solid 0.1rem #98A4AA33",
        minWidth: "18%",
        width: "18%",
        maxWidth: "18%",
        
        height: "100%",
        overflowY: "auto", 
        overflowX: "hidden",
      }}
    >
      <div className="sticky-actions-wrapper-cvhp">
        <ActionSection onSearchClick={toggleSearchPopup}  
        setSessionId={setSessionId}
        uniqueKey={uniqueKey}
        isHistoryVisible={isHistoryVisible}
        onToggleHistory={() => setIsHistoryVisible(!isHistoryVisible)}
         setSelectedIndex={setSelectedIndex}
         />
       
      </div>

      <SearchChatsPopup 
        isOpen={isSearchOpen} 
        onClose={toggleSearchPopup} 
        chatItems={chatHeadings} 
        onSelectChat={handleSelectChatFromSearch}
        uniqueKey={uniqueKey}
        setSelectedIndex={setSelectedIndex}
        setSessionId={setSessionId}
      />

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "1rem"
          }}
        >
          <IOSSpinner />
        </div>
      ) : (
        // isHistoryVisible && (
        //   <ChatHistorySection
        //     items={chatHeadings}
        //     selectedIndex={selectedIndex}
        //     onSelect={(index,item) => {setSelectedIndex(index); handleSelectForHistoryPanel(item)}}
        //   />
        // )
        
        <div className={`history-collapse-wrapper ${isHistoryVisible ? "open" : "closed"}`}>
  {isHistoryVisible && (
    <ChatHistorySection
      items={chatHeadings}
      selectedIndex={selectedIndex}
      onSelect={(index, item) => {
        setSelectedIndex(index);
        handleSelectForHistoryPanel(item);
      }}
    />
  )}
</div>

      )}
    </div>
  );
}

export default ChatV2HistoryPanel;
